<template lang="html">
  <div>

    <md-dialog ref="confirmDialog" id="confirmDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Confirmar Carrito</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          Desea pagar el pedido en linea o crear el pedido y pagar al momento de entrega
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        
            <md-button class="md-primary" id="entrar" @click.native="crearPedido">Crear Pedido</md-button>
            <md-button class="md-primary" id="cancelar" @click.native="pagar">Pagar</md-button>
        
      </md-dialog-actions>
    </md-dialog>

    <md-dialog ref="logInDialog" id="logInDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Iniciar sesión</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Nombre de usuario</label>
            <md-input v-model="usuario.usuario"></md-input>
          </md-input-container>
          <md-input-container>
            <md-icon>lock_outline</md-icon>
            <label>Contraseña</label>
            <md-input v-model="usuario.contrasena" type="password"></md-input>
          </md-input-container>
          <span @click="openModal('PassDialog')">
            <div id="ForgotPassword">¿Olvido su contraseña?</div>
          </span>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-layout>
          <md-layout md-align="start">
            <md-button class="md-accent" id="cancelar" @click.native="openModal('registroDialog')" >Registrarse</md-button>
          </md-layout>
          <md-layout md-align="end">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('logInDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="logIn">Entrar</md-button>
          </md-layout>
        </md-layout>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog ref="registroDialog" id="registroDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Registro</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content v-if="parametros">
        
        <md-layout md-gutter="16" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0'">
          <!-- <md-layout md-flex="100">
            <h2>Datos de Usuario</h2>
          </md-layout> -->
          <md-layout md-flex="100">
            <md-input-container>
              <label>Nombre de Usuario</label>
              <md-input required v-model="usuarioRegistro.cliente.usuario"></md-input>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="100">
            <md-input-container>
              <label>Email</label>
              <md-input required v-model="usuarioRegistro.cliente.email"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Nombre Fiscal</label>
              <md-input required v-model="usuarioRegistro.cliente.nombre"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Nombre Comercial</label>
              <md-input v-model="usuarioRegistro.cliente.comercial"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>RFC</label>
              <md-input v-model="usuarioRegistro.cliente.rfc"></md-input>
            </md-input-container>
          </md-layout>

          <!-- <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Dirección</label>
              <md-input required v-model="usuarioRegistro.cliente.direccion"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
            <md-input-container>
              <label>Num Exterior</label>
              <md-input required v-model="usuarioRegistro.cliente.numext"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
            <md-input-container>
              <label>Num interior</label>
              <md-input v-model="usuarioRegistro.cliente.numint"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Pais</label>
              <md-input required v-model="usuarioRegistro.cliente.pais"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Estado</label>
              <md-input required v-model="usuarioRegistro.cliente.entfed"></md-input>
            </md-input-container>
          </md-layout>


          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Ciudad</label>
              <md-input required v-model="usuarioRegistro.cliente.poblacion"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Colonia</label>
              <md-input v-model="usuarioRegistro.cliente.colonia"></md-input>
            </md-input-container>
          </md-layout> -->

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Telefono</label>
              <md-input type="number" v-model="usuarioRegistro.cliente.telefono" maxlength="5"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Contraseña</label>
              <md-input required type="password" v-model="usuarioRegistro.sTShop.contrasena"  @blur.native="checkPassword"></md-input>
            </md-input-container>
          </md-layout>
          
          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container >
              <label>Confirma Contraseña</label>
              <md-input required type="password" v-model="usuarioRegistro.confirmaContrasena" @blur.native="checkPassword"></md-input>
            </md-input-container>
            
          </md-layout>

          </md-layout>
        </md-layout>
        <md-layout v-else>
          Favor de comunicarse al 
          {{empresa.telefono + ' '}} 
          o enviar un correo a {{empresa.email  + ' '}}
          para solicitar su registro
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-accent" id="cancelar" @click.native="closeModal('registroDialog')">Cerrar</md-button>
        <md-button class="md-primary md-raised" id="entrar" @click.native="validateRegistro" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0'">Registrarse</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog ref="PassDialog" id="PassDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Recuperar Contraseña</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Email</label>
            <md-input v-model="emailRecupera"></md-input>
          </md-input-container>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-layout>
          <md-layout md-align="end">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('PassDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="resetPass">Recuperar Contraseña</md-button>
          </md-layout>
        </md-layout>
      </md-dialog-actions>
    </md-dialog>


    <md-layout md-gutter="16" v-if="showCart">
      <md-layout md-flex="65" md-flex-small="100" md-flex-xsmall="100" class="whiteframe">
        <md-layout v-if="cart.length === 0" md-align="center center">
          <div style="margin-top:80px; font-size:18px">No hay articulos en el carrito</div>
        </md-layout>
        <md-list class="custom-list md-triple-line" v-for="(cart, index) in cart" style="width:100%" key="index">
          <md-list-item class="cartItems">
            <md-layout md-gutter="16">

              <md-layout md-flex-xlarge="15"
                md-flex-large="15"
                md-flex-medium="20"
                md-flex-small="35"
                md-flex-xsmall="35" style="margin-right:10px;">
                <img class="cartImage" :id="`img${index}`" 
                v-if="cart.foto && cart.foto.replace(/ /g,'') !== '' && cart.foto.replace(/ /g,'') !== null" 
                :src="`${parametros.ruta_imagen}${cart.foto}`" style="width:90px; height: 90px"/>
              <img class="cartImage" id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" />
              </md-layout>

              <md-layout class="md-list-text-container"  md-flex-xlarge="50"
                md-flex-large="50"
                md-flex-medium="50"
                md-flex-small="60"
                md-flex-xsmall="60">
                <div class="md-title">{{cart.nombre}}</div>
                <div style="white-space:normal">{{cart.descripcion}}</div>
                <div>
                  <div class="cartDetails"> Precio: {{articuloPrecio(cart.precio)}}</div>
                  <div class="cartDetails" v-if="!cart.edition"> Cantidad: {{cart.cantidad}}</div>
                  <md-layout v-if="cart.edition">
                    <md-layout style="max-width: 20%;" md-flex="20" md-flex-small="100" md-flex-xsmall="100">
                      <md-input-container>
                        <label>Cantidad</label>
                        <md-input v-model="cart.cantidad"
                          type="number"
                          min="1"
                          ></md-input>
                      </md-input-container>
                    </md-layout>
                    <md-layout style="max-width: 20%; padding-top:15px" md-flex="20" md-flex-small="100" md-flex-xsmall="100">
                      <md-button class="md-icon-button md-list-action" @click.native="calculateTotal(index)">
                        <md-icon class="md-primary">save</md-icon>
                      </md-button>
                    </md-layout>
                  </md-layout>
                  <md-layout v-else md-align="start">
                    <md-button style="margin-left:-15px" class="md-accent" @click.native="editArticulo(index)">Modificar cantidad</md-button>
                  </md-layout>
                </div>
              </md-layout>

              <md-layout class="cartTotal"  md-flex-xlarge="20"
                md-flex-large="20"
                md-flex-medium="20"
                md-flex-small="80"
                md-flex-xsmall="80">
                {{toMoney(cart.precioTotal + cart.impuestos)}}
              </md-layout>
              <!--dasfdksjl-->
              <md-layout md-flex="10" md-align="end">
                <md-button class="md-icon-button md-list-action" @click.native="deleteFromCart(index)">
                  <md-icon class="md-primary">delete</md-icon>
                </md-button>
                <!-- <md-button style="max-width:50px" class="md-icon-button md-list-action" 
                  @click.native="editArticulo(index)"
                  v-if="!cart.edition">
                  <md-icon class="md-primary">edit</md-icon>
                </md-button>
                <md-button v-else style="max-width:50px" class="md-icon-button md-list-action" @click.native="calculateTotal(index)">
                  <md-icon class="md-primary">save</md-icon>
                </md-button> -->
              </md-layout>
              
            </md-layout>
            <md-divider class="md-inset"></md-divider>
          </md-list-item>
        </md-list>
      </md-layout>
      <md-layout md-flex class="whiteframe" md-column style="margin:5px;">
        <div md-align="start" class="totales">
          <span class="totalLabel">Subtotal: </span> <span class="totalData">{{toMoney(subtotal)}}</span>
        </div>
        <div md-align="start" class="totales">
          <span class="totalLabel">Impuestos: </span> <span class="totalData">{{impuestos == 0 ? '$ 0.00' : toMoney(impuestos)}}</span>
        </div>
        <!-- <div md-align="start" class="totales" v-if="parametros.metodo_envio.trim() === 'porcentaje'">
          <span class="totalLabel">Envio: </span> <span v-if="cart.length !== 0" class="totalData">{{toMoney(envio)}}</span>
        </div> -->
        <div md-align="start" class="totales">
          <span class="totalLabel">Total: </span> <span class="totalData">{{toMoney(subtotal + impuestos)}}</span>
        </div>
        <md-layout md-align="end" class="buttonCart">
          <div>
            <md-button class="md-accent" @click.native="goToCatalogo">Continuar Comprando</md-button>
            <md-button :disabled="cart.length === 0" class="md-primary md-raised" @click.native="checkCliente">Confirmar Carrito</md-button>
          </div>
        </md-layout>
      </md-layout>
    </md-layout>

  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';

export default {
  name: 'Inicial',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      cart: [],
      usuario: {},
      cliente: {},
      iva: 16,
      showCart: false,
      empresa: {},
      parametros: {},
      passwordEqual: true,
      usuarioRegistro: {
        cliente: {},
        sTShop: {},
      },
    };
  },
  computed: {
    isPasswordEqual() {
      return this.passwordEqual ? '' : 'md-input-invalid';
    },
    subtotal() {
      debugger
      let total = 0;
      this.cart.forEach((element) => {
        this.iva = element.pIva;
        total += element.precioTotal;
      });
      return total;
    },
    impuestos() {
      let total = 0;
      this.cart.forEach((element) => {
        total += element.impuestos ? element.impuestos : 0;
      });
        return total;
    },
    envio() {
      return (this.subtotal * (this.parametros.porcentaje_envio / 100)) * this.iva
    }
  },
  components: {},
  methods: {
    validateRegistro () {
        if(!this.usuarioRegistro.cliente.usuario && !this.usuarioRegistro.cliente.usuario.length > 0){
          this.$toast.create('El campo usuario es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.cliente.email && !this.usuarioRegistro.cliente.email.length > 0){
          this.$toast.create('El campo email es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.cliente.nombre && !this.usuarioRegistro.cliente.nombre.length > 0){
          this.$toast.create('El campo Nombre fiscal es obligatorio', 'snack', 3E3);
          return;
        } 
        // if(!this.usuarioRegistro.cliente.comercial && !this.usuarioRegistro.cliente.comercial.length > 0){
        //   this.$toast.create('El campo Nombre Comercial es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.rfc && !this.usuarioRegistro.cliente.rfc.length > 0){
        //   this.$toast.create('El campo RFC es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.direccion && !this.usuarioRegistro.cliente.direccion.length > 0){
        //   this.$toast.create('El campo Dirección es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.numext && !this.usuarioRegistro.cliente.numext.length > 0){
        //   this.$toast.create('El campo Num Exterior es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.pais && !this.usuarioRegistro.cliente.pais.length > 0){
        //   this.$toast.create('El campo País es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.entfed && !this.usuarioRegistro.cliente.entfed.length > 0){
        //   this.$toast.create('El campo Estado es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.poblacion && !this.usuarioRegistro.cliente.poblacion.length > 0){
        //   this.$toast.create('El campo Población es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.cp && !this.usuarioRegistro.cliente.cp.length > 0){
        //   this.$toast.create('El campo Codigo Postal es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        if(!this.usuarioRegistro.sTShop.contrasena && !this.usuarioRegistro.sTShop.contrasena.length > 0){
          this.$toast.create('El campo Contraseña es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.confirmaContrasena && !this.usuarioRegistro.confirmaContrasena.length > 0){
          this.$toast.create('El campo Confirma Contraseña es obligatorio', 'snack', 3E3);
          return;
        }
        if (!this.passwordEqual) {
          alert('El campo contraseña y confirmar contraseña no coinciden, Favor de Revisar estos campos');
          return;
        }
        this.registro();
      },
      registro() {
        this.usuarioRegistro.sTShop.usuario = this.usuarioRegistro.cliente.usuario
        this.usuarioRegistro.sTShop.email = this.usuarioRegistro.cliente.email
        this.usuarioRegistro.sTShop.RFC = this.usuarioRegistro.cliente.rfc
        this.resourceCliente.crear(this.usuarioRegistro)
        .then((response) => {
          const idusuario = response.body.idinterno;
            this.$toast.create('Cliente Registrado, inicie sesión', 'snack', 3E3);
            this.closeModal('registroDialog');
            this.checkCliente();
        })
        .catch((err) => {
          this.$toast.create('El Email o RFC ya existe', 'snack', 3E3);
        });
      },
    checkPassword() {
      this.passwordEqual =
        this.usuarioRegistro.sTShop.contrasena === this.usuarioRegistro.confirmaContrasena;
    },
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    articuloPrecio(precio) {
        if (precio) {
          return toMoney(parseFloat(precio, 10)); 
        }
        return 0.00;
      },
    deleteFromCart(index) {
      this.cart.splice(index, 1);
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
    },
    calculateTotal(index) {
      this.cantidad = this.cart[index].cantidad;
      this.cantidad = this.cantidad < 1 ? 1 : this.cantidad;
      this.cart[index].precioTotal = this.cantidad * parseFloat(this.cart[index].precioN).toFixed(2);
      this.cart[index].impuestos = this.cantidad * (parseFloat(this.cart[index].precio).toFixed(2) - parseFloat(this.cart[index].precioN).toFixed(2));
      this.cart[index].edition = false;
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
      this.cart = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : {};
    },
    editArticulo(index){
      this.cart[index].edition = true;
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
      this.$set(this.cart, JSON.parse(localStorage.getItem('cart')), JSON.parse(localStorage.getItem('cart')))
      // this.showCart = false;
      // setTimeout(() => {
      //   this.showCart = true;
      // }, 1E2);
    },
    deleteAllCart(){
      this.cart = [];
      window.cart = this.cart;
      localStorage.setItem('cart', JSON.stringify(this.cart));
      this.$root.$emit('setcart', this.cart);
    },
    checkCliente() {
      if(localStorage.getItem('cliente')){
        this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
        this.$router.replace({ name: 'pagos'});
        
      } else {
        this.openModal("logInDialog");
      }
    },
    logIn() {
      this.resourceCliente.logIn(this.usuario)
        .then((response) => {
          window.cliente = response.body;
          this.isUserLogged = true;
          localStorage.setItem('cliente', JSON.stringify(response.body));
          // this.$router.go(this.$router.currentRoute);
          // const route = this.$route.name;
          this.closeModal('logInDialog');
        })
        .catch((err) => {
          this.$toast.create('Usuario o Contraseña incorrectos', 'snack', 3E3);
        });
    },
    registro() {
      this.usuarioRegistro.sTShop.usuario = this.usuarioRegistro.cliente.usuario;
      this.usuarioRegistro.sTShop.email = this.usuarioRegistro.cliente.email;
      this.usuarioRegistro.sTShop.RFC = this.usuarioRegistro.cliente.rfc;
      this.resourceCliente.crear(this.usuarioRegistro)
      .then((response) => {
        const idusuario = response.body.idinterno;
        this.$toast.create('Cliente Registrado, inicie sesión', 'snack', 3E3);
        this.closeModal('registroDialog');
        this.checkCliente();
      })
      .catch((err) => {
        this.$toast.create('El Email o RFC ya existe', 'snack', 3E3);
      });
    },
    savePagoXCobrar(pedido){
      const idPedido = pedido.documento.idinterno;
      let idFormaPago = '';
      pedido.pagos.forEach((element) => {
        if(element.descripcion.trim() === 'POR COBRAR') {
          idFormaPago = element.idformapago;
        }
      })
      const pago = {
        idformapago: idFormaPago,
        valor: pedido.documento.TOTAL
      };

      this.resourcePedido.pagos({ idPedido }, pago)
        .then((response) => {
              //this.$toast.create('Pedido Creado', 'snack', 3E3);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    savePedido() {
      let detalles = [];
      this.cart.forEach((element) => {
        const detalle = {
          idarticulo: element.idinterno,
          cantidad: element.cantidad,
          precio: element.precio / element.pIva
        }
        if (element.idsecundaria) {
          detalle.idsecundaria = element.idsecundaria; 
        }
        if (element.id_presentacion) {
          detalle.id_presentacion = element.id_presentacion; 
        }
        detalles.push(detalle);
      });
      const pedido = {
        documento: {
          turno: 'M',
          idvendedor: 'STSHOPVEND',
          idcliente: this.cliente.cliente.idinterno,
          detalles: detalles,
          _esBorrador: false,
        }
      }
      this.resourcePedido.guardar(pedido)
        .then((response) => {
          const idPedido = response.body.idinterno;
              this.$toast.create('Pedido Creado', 'snack', 3E3);
              this.deleteAllCart();
              this.$router.replace({ name: 'pagos', params: { idPedido: idPedido }});
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    toMoney,
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
  },
  mounted() {
    var count = 0
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
    this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {}; 
    this.empresa = localStorage.getItem('empresa') ? JSON.parse(localStorage.getItem('empresa')) : {}; 
    localStorage.setItem("ultimaPagina", 'carrito'); 
    setTimeout(() => {
      this.cart = window.cart;
      this.cart.map((el) => {
        el.edition = false;
      })
      this.showCart = true;
      if (count === 0) {
        count++;
        this.showCart = false;
        setTimeout(() => {
          this.cart = window.cart;
          this.showCart = true;
        }, 1E2); 
      }
    }, 1E2);
    this.calculateTotal(0);
  },
};
</script>

<style lang="scss">
.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/spa/carrito/Carrito.vue